import React from 'react';

export const RotateCcwIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} {...props}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 3L6 6m0 0l3 3M6 6h11a4 4 0 014 4v2" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 21l3-3m0 0l-3-3m3 3H7a4 4 0 01-4-4v-2" />
  </svg>
);